(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mt-exit-discount"] && !Shopify.designMode) return;
  try {
    (() => {
    const mtMadeWith = "Made with ♥ by Mister Topdesign";
    const mtDay = 86_400_000;
    const mtClamp = (mtValue, mtMinimum, mtMaximum, mtFallback) => {
      const mtNumber = Number(mtValue);
      return Number.isFinite(mtNumber)
        ? Math.min(mtMaximum, Math.max(mtMinimum, mtNumber))
        : mtFallback;
    };
    const mtRead = (mtStorage, mtKey) => {
      try {
        return mtStorage.getItem(mtKey);
      } catch {
        return null;
      }
    };
    const mtWrite = (mtStorage, mtKey, mtValue) => {
      try {
        mtStorage.setItem(mtKey, mtValue);
      } catch {
        return;
      }
    };

    const mtRoots = [...document.querySelectorAll(".mt-exit-discount")];
    const mtPreferredRoot =
      mtRoots.find((mtRoot) => mtRoot.dataset.mtSource === "theme") || mtRoots[0];
    mtRoots.forEach((mtRoot) => {
      if (mtRoot === mtPreferredRoot) return;
      const mtDuplicateDialog = mtRoot.querySelector(".mt-exit-discount-dialog");
      if (mtDuplicateDialog) {
        mtDuplicateDialog.hidden = true;
        if (mtDuplicateDialog.open && typeof mtDuplicateDialog.close === "function") {
          mtDuplicateDialog.close();
        }
      }
      mtRoot.hidden = true;
      mtRoot.inert = true;
      mtRoot.setAttribute("aria-hidden", "true");
      mtRoot.dataset.mtReady = "duplicate";
      mtRoot.dataset.mtSignature = mtMadeWith;
    });

    document
      .querySelectorAll(".mt-exit-discount:not([data-mt-ready])")
      .forEach((mtRoot) => {
        if (mtRoot !== mtPreferredRoot) return;
        mtRoot.dataset.mtReady = "true";
        mtRoot.dataset.mtSignature = mtMadeWith;

        const mtDialog = mtRoot.querySelector(".mt-exit-discount-dialog");
        const mtClose = mtRoot.querySelector(".mt-exit-discount-close");
        const mtDecline = mtRoot.querySelector(".mt-exit-discount-decline");
        const mtActivate = mtRoot.querySelector(".mt-exit-discount-activate");
        const mtCodeButton = mtRoot.querySelector(".mt-exit-discount-code-button");
        const mtCopyLabel = mtRoot.querySelector(".mt-exit-discount-copy-label");
        if (!mtDialog || !mtClose || !mtDecline || !mtActivate || !mtCodeButton || !mtCopyLabel) return;

        const mtCode = (mtRoot.dataset.mtCode || "").trim();
        if (!/^[A-Za-z0-9_-]{2,40}$/.test(mtCode)) return;

        const mtDelay = mtClamp(mtRoot.dataset.mtDelaySeconds, 5, 120, 30) * 1000;
        const mtMinimumPageviews = mtClamp(mtRoot.dataset.mtMinPageviews, 1, 5, 2);
        const mtScrollThreshold = mtClamp(mtRoot.dataset.mtScrollPercent, 10, 80, 35);
        const mtSuppressDays = mtClamp(mtRoot.dataset.mtSuppressDays, 1, 30, 7);
        const mtMobileEnabled = mtRoot.dataset.mtMobileEnabled === "true";
        const mtDesignMode = Boolean(window.Shopify?.designMode);
        const mtShop = mtRoot.dataset.mtShop || location.hostname;
        const mtCampaignKey = `${mtShop}-${mtCode.toLowerCase()}`;
        const mtStateKey = `mt-exit-discount-state-${mtShop}`;
        const mtShownKey = `mt-exit-discount-shown-${mtCampaignKey}`;
        const mtPageviewKey = `mt-exit-discount-pageviews-${mtShop}`;
        const mtExcludedPath =
          /(^|\/(?:[a-z]{2}(?:-[a-z]{2})?)?\/)(?:account|accounts|checkout|checkouts|orders)(?:\/|$)/i;
        if (mtExcludedPath.test(location.pathname)) return;

        let mtState = {};
        try {
          mtState = JSON.parse(mtRead(localStorage, mtStateKey) || "{}") || {};
        } catch {
          mtState = {};
        }
        if (
          !mtDesignMode &&
          mtState.code === mtCode &&
          Number(mtState.suppressedUntil) > Date.now()
        ) return;
        if (!mtDesignMode && mtRead(sessionStorage, mtShownKey) === "true") return;

        const mtPreviousPageviews = Number(mtRead(sessionStorage, mtPageviewKey) || 0);
        const mtPageviews = Number.isFinite(mtPreviousPageviews)
          ? Math.min(99, mtPreviousPageviews + 1)
          : 1;
        mtWrite(sessionStorage, mtPageviewKey, String(mtPageviews));

        const mtRootPath = (mtRoot.dataset.mtRootUrl || "/").replace(/\/?$/, "/");
        const mtReturnUrl = `${location.pathname}${location.search}`;
        mtActivate.href = `${mtRootPath}discount/${encodeURIComponent(mtCode)}?redirect=${encodeURIComponent(mtReturnUrl)}`;

        const mtCoarsePointer = matchMedia("(hover: none), (pointer: coarse)").matches;
        let mtTimeReady = false;
        let mtEngaged = mtPageviews >= mtMinimumPageviews;
        let mtOpened = false;
        let mtDismissed = false;
        let mtLastFocus = null;
        let mtMaximumScrollY = Math.max(0, window.scrollY);
        let mtLastScrollY = Math.max(0, window.scrollY);
        let mtUpwardDistance = 0;
        let mtLastScrollAt = 0;

        const mtEmit = (mtName, mtReason) => {
          mtRoot.dispatchEvent(
            new CustomEvent(`mt-exit-discount:${mtName}`, {
              detail: { code: mtCode, reason: mtReason },
            }),
          );
        };
        const mtBlocked = () => {
          const mtLivechat = document.querySelector("#mt-livechat-panel");
          const mtOtherDialog = document.querySelector("dialog[open]:not(.mt-exit-discount-dialog)");
          return Boolean(mtOtherDialog || (mtLivechat && !mtLivechat.hidden));
        };
        const mtEligible = () =>
          mtTimeReady &&
          mtEngaged &&
          !mtOpened &&
          !mtDismissed &&
          document.visibilityState === "visible" &&
          !mtBlocked();
        const mtShow = (mtReason) => {
          if (!mtEligible()) return false;
          mtOpened = true;
          mtLastFocus = document.activeElement;
          if (!mtDesignMode) mtWrite(sessionStorage, mtShownKey, "true");
          document.documentElement.classList.add("mt-exit-discount-lock");
          if (typeof mtDialog.showModal === "function") mtDialog.showModal();
          else mtDialog.setAttribute("open", "");
          mtClose.focus({ preventScroll: true });
          mtEmit("shown", mtReason);
          return true;
        };
        const mtSuppress = (mtReason, mtDays = mtSuppressDays) => {
          mtDismissed = true;
          if (mtDesignMode) return;
          mtWrite(
            localStorage,
            mtStateKey,
            JSON.stringify({
              code: mtCode,
              reason: mtReason,
              suppressedUntil: Date.now() + mtDays * mtDay,
            }),
          );
        };
        const mtHide = (mtReason) => {
          if (!mtOpened) return;
          mtSuppress(mtReason);
          mtOpened = false;
          document.documentElement.classList.remove("mt-exit-discount-lock");
          if (typeof mtDialog.close === "function") mtDialog.close();
          else mtDialog.removeAttribute("open");
          if (mtLastFocus instanceof HTMLElement && mtLastFocus.isConnected) {
            mtLastFocus.focus({ preventScroll: true });
          }
          mtEmit("dismissed", mtReason);
        };

        mtClose.addEventListener("click", () => mtHide("close"));
        mtDecline.addEventListener("click", () => mtHide("decline"));
        mtDialog.addEventListener("cancel", (mtEvent) => {
          mtEvent.preventDefault();
          mtHide("escape");
        });
        mtDialog.addEventListener("click", (mtEvent) => {
          if (mtEvent.target !== mtDialog) return;
          const mtRect = mtDialog.getBoundingClientRect();
          const mtInside =
            mtEvent.clientX >= mtRect.left &&
            mtEvent.clientX <= mtRect.right &&
            mtEvent.clientY >= mtRect.top &&
            mtEvent.clientY <= mtRect.bottom;
          if (!mtInside) mtHide("backdrop");
        });
        mtActivate.addEventListener("click", (mtEvent) => {
          if (mtDesignMode) mtEvent.preventDefault();
          mtSuppress("activated", Math.max(mtSuppressDays, 30));
          mtEmit("activated", "primary");
        });
        mtCodeButton.addEventListener("click", async () => {
          try {
            await navigator.clipboard.writeText(mtCode);
            const mtOriginal = mtCopyLabel.textContent;
            mtCopyLabel.textContent = mtRoot.dataset.mtCopiedLabel || mtOriginal;
            mtCodeButton.classList.add("mt-exit-discount-code-copied");
            mtEmit("copied", "code");
            window.setTimeout(() => {
              mtCopyLabel.textContent = mtOriginal;
              mtCodeButton.classList.remove("mt-exit-discount-code-copied");
            }, 1800);
          } catch {
            mtCodeButton.classList.add("mt-exit-discount-code-selected");
          }
        });

        const mtMarkEngaged = () => {
          mtEngaged = true;
        };
        window.addEventListener("pointerdown", mtMarkEngaged, { once: true, passive: true });
        window.addEventListener("keydown", mtMarkEngaged, { once: true });
        document.addEventListener("mouseout", (mtEvent) => {
          if (mtCoarsePointer || mtEvent.relatedTarget || mtEvent.clientY > 10) return;
          mtShow("desktop-exit");
        });
        window.addEventListener(
          "scroll",
          () => {
            const mtNow = Date.now();
            const mtCurrentY = Math.max(0, window.scrollY);
            mtMaximumScrollY = Math.max(mtMaximumScrollY, mtCurrentY);
            const mtScrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
            if ((mtMaximumScrollY / mtScrollable) * 100 >= mtScrollThreshold) mtEngaged = true;

            if (mtNow - mtLastScrollAt > 700 || mtCurrentY >= mtLastScrollY) mtUpwardDistance = 0;
            else mtUpwardDistance += mtLastScrollY - mtCurrentY;
            mtLastScrollAt = mtNow;
            mtLastScrollY = mtCurrentY;

            if (
              mtMobileEnabled &&
              mtCoarsePointer &&
              mtMaximumScrollY >= Math.max(280, window.innerHeight * 0.45) &&
              mtUpwardDistance >= Math.min(220, window.innerHeight * 0.28)
            ) {
              mtUpwardDistance = 0;
              mtShow("mobile-return");
            }
          },
          { passive: true },
        );

        window.setTimeout(() => {
          mtTimeReady = true;
        }, mtDelay);
        if (mtDesignMode) {
          mtTimeReady = true;
          mtEngaged = true;
          window.setTimeout(() => mtShow("theme-editor"), 450);
        }
      });
  })();
  } catch(e) { console.error(e); }
})();

})();
